/* eslint-disable */
// @ts-nocheck
// source: internal/opportunity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
var shared_types_interval_pb = require('../shared/types/interval_pb.js');
goog.object.extend(proto, shared_types_interval_pb);
var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
goog.exportSymbol('proto.worklayer.internal.v1.ApplyToOpportunityRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ApplyToOpportunityResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DeclineOpportunityOfferRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.DeclineOpportunityOfferResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetCandidaciesRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetCandidaciesResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetOpportunityOfferRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.GetOpportunityRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListOpportunitiesRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListOpportunitiesResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListOpportunityOffersRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListOpportunityOffersResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListQualifiedProvidersRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.ListQualifiedProvidersResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.Client', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.Consultation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.InfoLine', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.JobScopeInventoryItemType', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.JobScopeItem', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.Legend', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.RoutingMode', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Opportunity.Workspace', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityOffer', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityOffer.Client', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityOffer.Consultation', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityOffer.ExpirationAction', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.Provider', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.WithdrawApplicationRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.v1.WithdrawApplicationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetOpportunityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetOpportunityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetOpportunityRequest.displayName = 'proto.worklayer.internal.v1.GetOpportunityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListOpportunitiesRequest.displayName = 'proto.worklayer.internal.v1.ListOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListQualifiedProvidersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListQualifiedProvidersRequest.displayName = 'proto.worklayer.internal.v1.ListQualifiedProvidersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListOpportunitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListOpportunitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListOpportunitiesResponse.displayName = 'proto.worklayer.internal.v1.ListOpportunitiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ApplyToOpportunityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ApplyToOpportunityRequest.displayName = 'proto.worklayer.internal.v1.ApplyToOpportunityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ApplyToOpportunityResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ApplyToOpportunityResponse.displayName = 'proto.worklayer.internal.v1.ApplyToOpportunityResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.WithdrawApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.WithdrawApplicationRequest.displayName = 'proto.worklayer.internal.v1.WithdrawApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.WithdrawApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.WithdrawApplicationResponse.displayName = 'proto.worklayer.internal.v1.WithdrawApplicationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetCandidaciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetCandidaciesRequest.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetCandidaciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetCandidaciesRequest.displayName = 'proto.worklayer.internal.v1.GetCandidaciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetCandidaciesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.GetCandidaciesResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.GetCandidaciesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetCandidaciesResponse.displayName = 'proto.worklayer.internal.v1.GetCandidaciesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.displayName = 'proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.ListOpportunityOffersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListOpportunityOffersRequest.displayName = 'proto.worklayer.internal.v1.ListOpportunityOffersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListOpportunityOffersResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListOpportunityOffersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListOpportunityOffersResponse.displayName = 'proto.worklayer.internal.v1.ListOpportunityOffersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.GetOpportunityOfferRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.GetOpportunityOfferRequest.displayName = 'proto.worklayer.internal.v1.GetOpportunityOfferRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.DeclineOpportunityOfferRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.displayName = 'proto.worklayer.internal.v1.DeclineOpportunityOfferRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.DeclineOpportunityOfferResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.displayName = 'proto.worklayer.internal.v1.DeclineOpportunityOfferResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityOffer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.OpportunityOffer.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityOffer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityOffer.displayName = 'proto.worklayer.internal.v1.OpportunityOffer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityOffer.Client = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityOffer.Client, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityOffer.Client.displayName = 'proto.worklayer.internal.v1.OpportunityOffer.Client';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.OpportunityOffer.Consultation.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityOffer.Consultation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityOffer.Consultation.displayName = 'proto.worklayer.internal.v1.OpportunityOffer.Consultation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Opportunity.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.displayName = 'proto.worklayer.internal.v1.Opportunity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity.Workspace = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity.Workspace, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.Workspace.displayName = 'proto.worklayer.internal.v1.Opportunity.Workspace';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity.Client = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity.Client, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.Client.displayName = 'proto.worklayer.internal.v1.Opportunity.Client';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity.InfoLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity.InfoLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.InfoLine.displayName = 'proto.worklayer.internal.v1.Opportunity.InfoLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity.Legend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity.Legend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.Legend.displayName = 'proto.worklayer.internal.v1.Opportunity.Legend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity.Consultation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.Opportunity.Consultation.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity.Consultation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.Consultation.displayName = 'proto.worklayer.internal.v1.Opportunity.Consultation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Opportunity.JobScopeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Opportunity.JobScopeItem.displayName = 'proto.worklayer.internal.v1.Opportunity.JobScopeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.worklayer.internal.v1.ListQualifiedProvidersResponse.repeatedFields_, null);
};
goog.inherits(proto.worklayer.internal.v1.ListQualifiedProvidersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.ListQualifiedProvidersResponse.displayName = 'proto.worklayer.internal.v1.ListQualifiedProvidersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.displayName = 'proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.displayName = 'proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.displayName = 'proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.Provider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.Provider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.Provider.displayName = 'proto.worklayer.internal.v1.Provider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.displayName = 'proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetOpportunityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetOpportunityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetOpportunityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetOpportunityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetOpportunityRequest}
 */
proto.worklayer.internal.v1.GetOpportunityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetOpportunityRequest;
  return proto.worklayer.internal.v1.GetOpportunityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetOpportunityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetOpportunityRequest}
 */
proto.worklayer.internal.v1.GetOpportunityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetOpportunityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetOpportunityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetOpportunityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetOpportunityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetOpportunityRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetOpportunityRequest} returns this
 */
proto.worklayer.internal.v1.GetOpportunityRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orderBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
    searchText: jspb.Message.getFieldWithDefault(msg, 4, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListOpportunitiesRequest;
  return proto.worklayer.internal.v1.ListOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderBy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string order_by = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.getOrderBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string search_text = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string workspace_id = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListQualifiedProvidersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListQualifiedProvidersRequest;
  return proto.worklayer.internal.v1.ListQualifiedProvidersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListQualifiedProvidersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page_size = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string page_token = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersRequest} returns this
 */
proto.worklayer.internal.v1.ListQualifiedProvidersRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListOpportunitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListOpportunitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunitiesList: jspb.Message.toObjectList(msg.getOpportunitiesList(),
    proto.worklayer.internal.v1.Opportunity.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesResponse}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListOpportunitiesResponse;
  return proto.worklayer.internal.v1.ListOpportunitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListOpportunitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesResponse}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Opportunity;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.deserializeBinaryFromReader);
      msg.addOpportunities(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListOpportunitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListOpportunitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.Opportunity.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Opportunity opportunities = 1;
 * @return {!Array<!proto.worklayer.internal.v1.Opportunity>}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.getOpportunitiesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Opportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Opportunity, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Opportunity>} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesResponse} returns this
*/
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.setOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Opportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Opportunity}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.addOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.Opportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesResponse} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.clearOpportunitiesList = function() {
  return this.setOpportunitiesList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunitiesResponse} returns this
 */
proto.worklayer.internal.v1.ListOpportunitiesResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ApplyToOpportunityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ApplyToOpportunityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ApplyToOpportunityRequest}
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ApplyToOpportunityRequest;
  return proto.worklayer.internal.v1.ApplyToOpportunityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ApplyToOpportunityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ApplyToOpportunityRequest}
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ApplyToOpportunityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ApplyToOpportunityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ApplyToOpportunityRequest} returns this
 */
proto.worklayer.internal.v1.ApplyToOpportunityRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ApplyToOpportunityResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ApplyToOpportunityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ApplyToOpportunityResponse}
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ApplyToOpportunityResponse;
  return proto.worklayer.internal.v1.ApplyToOpportunityResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ApplyToOpportunityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ApplyToOpportunityResponse}
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ApplyToOpportunityResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ApplyToOpportunityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ApplyToOpportunityResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.WithdrawApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.WithdrawApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.WithdrawApplicationRequest}
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.WithdrawApplicationRequest;
  return proto.worklayer.internal.v1.WithdrawApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.WithdrawApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.WithdrawApplicationRequest}
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.WithdrawApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.WithdrawApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.WithdrawApplicationRequest} returns this
 */
proto.worklayer.internal.v1.WithdrawApplicationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.WithdrawApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.WithdrawApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.WithdrawApplicationResponse}
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.WithdrawApplicationResponse;
  return proto.worklayer.internal.v1.WithdrawApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.WithdrawApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.WithdrawApplicationResponse}
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.WithdrawApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.WithdrawApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.WithdrawApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetCandidaciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetCandidaciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesRequest}
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetCandidaciesRequest;
  return proto.worklayer.internal.v1.GetCandidaciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetCandidaciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesRequest}
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetCandidaciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetCandidaciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.GetCandidaciesRequest} returns this
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.GetCandidaciesRequest} returns this
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesRequest} returns this
 */
proto.worklayer.internal.v1.GetCandidaciesRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetCandidaciesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    candidaciesList: jspb.Message.toObjectList(msg.getCandidaciesList(),
    proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetCandidaciesResponse;
  return proto.worklayer.internal.v1.GetCandidaciesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy;
      reader.readMessage(value,proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.deserializeBinaryFromReader);
      msg.addCandidacies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetCandidaciesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCandidaciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy;
  return proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy} returns this
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Candidacy candidacies = 1;
 * @return {!Array<!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy>}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.prototype.getCandidaciesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy>} value
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse} returns this
*/
proto.worklayer.internal.v1.GetCandidaciesResponse.prototype.setCandidaciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy}
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.prototype.addCandidacies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.GetCandidaciesResponse.Candidacy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.GetCandidaciesResponse} returns this
 */
proto.worklayer.internal.v1.GetCandidaciesResponse.prototype.clearCandidaciesList = function() {
  return this.setCandidaciesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListOpportunityOffersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListOpportunityOffersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersRequest}
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListOpportunityOffersRequest;
  return proto.worklayer.internal.v1.ListOpportunityOffersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListOpportunityOffersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersRequest}
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListOpportunityOffersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListOpportunityOffersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersRequest} returns this
 */
proto.worklayer.internal.v1.ListOpportunityOffersRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListOpportunityOffersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListOpportunityOffersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    offersList: jspb.Message.toObjectList(msg.getOffersList(),
    proto.worklayer.internal.v1.OpportunityOffer.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersResponse}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListOpportunityOffersResponse;
  return proto.worklayer.internal.v1.ListOpportunityOffersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListOpportunityOffersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersResponse}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.OpportunityOffer;
      reader.readMessage(value,proto.worklayer.internal.v1.OpportunityOffer.deserializeBinaryFromReader);
      msg.addOffers(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListOpportunityOffersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListOpportunityOffersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.OpportunityOffer.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated OpportunityOffer offers = 1;
 * @return {!Array<!proto.worklayer.internal.v1.OpportunityOffer>}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.getOffersList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.OpportunityOffer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.OpportunityOffer, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.OpportunityOffer>} value
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersResponse} returns this
*/
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.setOffersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.OpportunityOffer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.OpportunityOffer}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.addOffers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.OpportunityOffer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersResponse} returns this
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.clearOffersList = function() {
  return this.setOffersList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListOpportunityOffersResponse} returns this
 */
proto.worklayer.internal.v1.ListOpportunityOffersResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.GetOpportunityOfferRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.GetOpportunityOfferRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.GetOpportunityOfferRequest}
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.GetOpportunityOfferRequest;
  return proto.worklayer.internal.v1.GetOpportunityOfferRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.GetOpportunityOfferRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.GetOpportunityOfferRequest}
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.GetOpportunityOfferRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.GetOpportunityOfferRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.GetOpportunityOfferRequest} returns this
 */
proto.worklayer.internal.v1.GetOpportunityOfferRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DeclineOpportunityOfferRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DeclineOpportunityOfferRequest}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DeclineOpportunityOfferRequest;
  return proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DeclineOpportunityOfferRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DeclineOpportunityOfferRequest}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DeclineOpportunityOfferRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.DeclineOpportunityOfferRequest} returns this
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.DeclineOpportunityOfferResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.DeclineOpportunityOfferResponse}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.DeclineOpportunityOfferResponse;
  return proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.DeclineOpportunityOfferResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.DeclineOpportunityOfferResponse}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.DeclineOpportunityOfferResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.DeclineOpportunityOfferResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.OpportunityOffer.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityOffer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityOffer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOffer.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    legendName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    client: (f = msg.getClient()) && proto.worklayer.internal.v1.OpportunityOffer.Client.toObject(includeInstance, f),
    specsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    providerCutAmount: (f = msg.getProviderCutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    consultation: (f = msg.getConsultation()) && proto.worklayer.internal.v1.OpportunityOffer.Consultation.toObject(includeInstance, f),
    dateOffered: (f = msg.getDateOffered()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateExpires: (f = msg.getDateExpires()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    expirationAction: jspb.Message.getFieldWithDefault(msg, 12, 0),
    targeted: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer}
 */
proto.worklayer.internal.v1.OpportunityOffer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityOffer;
  return proto.worklayer.internal.v1.OpportunityOffer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityOffer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer}
 */
proto.worklayer.internal.v1.OpportunityOffer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegendName(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.OpportunityOffer.Client;
      reader.readMessage(value,proto.worklayer.internal.v1.OpportunityOffer.Client.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addSpecs(value);
      break;
    case 8:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderCutAmount(value);
      break;
    case 9:
      var value = new proto.worklayer.internal.v1.OpportunityOffer.Consultation;
      reader.readMessage(value,proto.worklayer.internal.v1.OpportunityOffer.Consultation.deserializeBinaryFromReader);
      msg.setConsultation(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateOffered(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateExpires(value);
      break;
    case 12:
      var value = /** @type {!proto.worklayer.internal.v1.OpportunityOffer.ExpirationAction} */ (reader.readEnum());
      msg.setExpirationAction(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTargeted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityOffer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityOffer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOffer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLegendName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.OpportunityOffer.Client.serializeBinaryToWriter
    );
  }
  f = message.getSpecsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getProviderCutAmount();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getConsultation();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.worklayer.internal.v1.OpportunityOffer.Consultation.serializeBinaryToWriter
    );
  }
  f = message.getDateOffered();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateExpires();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpirationAction();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getTargeted();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.OpportunityOffer.ExpirationAction = {
  UNSPECIFIED: 0,
  ACCEPT: 1,
  DECLINE: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityOffer.Client.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.toObject = function(includeInstance, msg) {
  var f, obj = {
    userPublicId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    givenName: (f = msg.getGivenName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    familyName: (f = msg.getFamilyName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    displayName: (f = msg.getDisplayName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    picture: (f = msg.getPicture()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityOffer.Client;
  return proto.worklayer.internal.v1.OpportunityOffer.Client.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGivenName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFamilyName(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDisplayName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPicture(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityOffer.Client.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGivenName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFamilyName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPicture();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_public_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue given_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.getGivenName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.setGivenName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.clearGivenName = function() {
  return this.setGivenName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.hasGivenName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue family_name = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.getFamilyName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.setFamilyName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.clearFamilyName = function() {
  return this.setFamilyName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.hasFamilyName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue display_name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.getDisplayName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.setDisplayName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.clearDisplayName = function() {
  return this.setDisplayName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.hasDisplayName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue picture = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.getPicture = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.setPicture = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.clearPicture = function() {
  return this.setPicture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.Client.prototype.hasPicture = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityOffer.Consultation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    availabilityTimesList: jspb.Message.toObjectList(msg.getAvailabilityTimesList(),
    shared_types_interval_pb.Interval.toObject, includeInstance),
    requestedLength: (f = msg.getRequestedLength()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityOffer.Consultation;
  return proto.worklayer.internal.v1.OpportunityOffer.Consultation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.addAvailabilityTimes(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRequestedLength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityOffer.Consultation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvailabilityTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
  f = message.getRequestedLength();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated worklayer.shared.types.v1.Interval availability_times = 2;
 * @return {!Array<!proto.worklayer.shared.types.v1.Interval>}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.getAvailabilityTimesList = function() {
  return /** @type{!Array<!proto.worklayer.shared.types.v1.Interval>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_interval_pb.Interval, 2));
};


/**
 * @param {!Array<!proto.worklayer.shared.types.v1.Interval>} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.setAvailabilityTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.shared.types.v1.Interval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.addAvailabilityTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.shared.types.v1.Interval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.clearAvailabilityTimesList = function() {
  return this.setAvailabilityTimesList([]);
};


/**
 * optional google.protobuf.Duration requested_length = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.getRequestedLength = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.setRequestedLength = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.Consultation} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.clearRequestedLength = function() {
  return this.setRequestedLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.Consultation.prototype.hasRequestedLength = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string legend_name = 5;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getLegendName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setLegendName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Client client = 6;
 * @return {?proto.worklayer.internal.v1.OpportunityOffer.Client}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getClient = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityOffer.Client} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.OpportunityOffer.Client, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityOffer.Client|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.hasClient = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string specs = 7;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getSpecsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setSpecsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.addSpecs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.clearSpecsList = function() {
  return this.setSpecsList([]);
};


/**
 * optional worklayer.shared.types.v1.Decimal provider_cut_amount = 8;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getProviderCutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 8));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.prototype.setProviderCutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.clearProviderCutAmount = function() {
  return this.setProviderCutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.hasProviderCutAmount = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Consultation consultation = 9;
 * @return {?proto.worklayer.internal.v1.OpportunityOffer.Consultation}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getConsultation = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityOffer.Consultation} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.OpportunityOffer.Consultation, 9));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityOffer.Consultation|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.prototype.setConsultation = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.clearConsultation = function() {
  return this.setConsultation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.hasConsultation = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp date_offered = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getDateOffered = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.prototype.setDateOffered = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.clearDateOffered = function() {
  return this.setDateOffered(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.hasDateOffered = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp date_expires = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getDateExpires = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
*/
proto.worklayer.internal.v1.OpportunityOffer.prototype.setDateExpires = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.clearDateExpires = function() {
  return this.setDateExpires(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.hasDateExpires = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ExpirationAction expiration_action = 12;
 * @return {!proto.worklayer.internal.v1.OpportunityOffer.ExpirationAction}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getExpirationAction = function() {
  return /** @type {!proto.worklayer.internal.v1.OpportunityOffer.ExpirationAction} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.OpportunityOffer.ExpirationAction} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setExpirationAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional bool targeted = 13;
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.getTargeted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.OpportunityOffer} returns this
 */
proto.worklayer.internal.v1.OpportunityOffer.prototype.setTargeted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Opportunity.repeatedFields_ = [7,8,14,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    workspace: (f = msg.getWorkspace()) && proto.worklayer.internal.v1.Opportunity.Workspace.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    client: (f = msg.getClient()) && proto.worklayer.internal.v1.Opportunity.Client.toObject(includeInstance, f),
    legend: (f = msg.getLegend()) && proto.worklayer.internal.v1.Opportunity.Legend.toObject(includeInstance, f),
    specsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    infoLinesList: jspb.Message.toObjectList(msg.getInfoLinesList(),
    proto.worklayer.internal.v1.Opportunity.InfoLine.toObject, includeInstance),
    dateDeadline: (f = msg.getDateDeadline()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateModified: (f = msg.getDateModified()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTransmitted: (f = msg.getDateTransmitted()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    providerCutAmount: (f = msg.getProviderCutAmount()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    legacyJobScopeItemsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    consultation: (f = msg.getConsultation()) && proto.worklayer.internal.v1.Opportunity.Consultation.toObject(includeInstance, f),
    routingMode: jspb.Message.getFieldWithDefault(msg, 16, 0),
    dateScheduledDispatch: (f = msg.getDateScheduledDispatch()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    jobScopeItemsList: jspb.Message.toObjectList(msg.getJobScopeItemsList(),
    proto.worklayer.internal.v1.Opportunity.JobScopeItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity}
 */
proto.worklayer.internal.v1.Opportunity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity;
  return proto.worklayer.internal.v1.Opportunity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity}
 */
proto.worklayer.internal.v1.Opportunity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.Opportunity.Workspace;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.Workspace.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = new proto.worklayer.internal.v1.Opportunity.Client;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.Client.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 6:
      var value = new proto.worklayer.internal.v1.Opportunity.Legend;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.Legend.deserializeBinaryFromReader);
      msg.setLegend(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addSpecs(value);
      break;
    case 8:
      var value = new proto.worklayer.internal.v1.Opportunity.InfoLine;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.InfoLine.deserializeBinaryFromReader);
      msg.addInfoLines(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateDeadline(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateModified(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTransmitted(value);
      break;
    case 13:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setProviderCutAmount(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addLegacyJobScopeItems(value);
      break;
    case 15:
      var value = new proto.worklayer.internal.v1.Opportunity.Consultation;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.Consultation.deserializeBinaryFromReader);
      msg.setConsultation(value);
      break;
    case 16:
      var value = /** @type {!proto.worklayer.internal.v1.Opportunity.RoutingMode} */ (reader.readEnum());
      msg.setRoutingMode(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateScheduledDispatch(value);
      break;
    case 18:
      var value = new proto.worklayer.internal.v1.Opportunity.JobScopeItem;
      reader.readMessage(value,proto.worklayer.internal.v1.Opportunity.JobScopeItem.deserializeBinaryFromReader);
      msg.addJobScopeItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.Opportunity.Workspace.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.worklayer.internal.v1.Opportunity.Client.serializeBinaryToWriter
    );
  }
  f = message.getLegend();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.worklayer.internal.v1.Opportunity.Legend.serializeBinaryToWriter
    );
  }
  f = message.getSpecsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getInfoLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.worklayer.internal.v1.Opportunity.InfoLine.serializeBinaryToWriter
    );
  }
  f = message.getDateDeadline();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateModified();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTransmitted();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProviderCutAmount();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getLegacyJobScopeItemsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getConsultation();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.worklayer.internal.v1.Opportunity.Consultation.serializeBinaryToWriter
    );
  }
  f = message.getRoutingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      16,
      f
    );
  }
  f = message.getDateScheduledDispatch();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getJobScopeItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      proto.worklayer.internal.v1.Opportunity.JobScopeItem.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeInventoryItemType = {
  DEFAULT: 0,
  BOOKKEEPING: 1,
  CONSULTATION: 2,
  TAX: 3
};

/**
 * @enum {number}
 */
proto.worklayer.internal.v1.Opportunity.RoutingMode = {
  UNSPECIFIED: 0,
  FIRST_COME_FIRST_SERVED: 1,
  DISPATCH: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.Workspace.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.Workspace.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity.Workspace} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Workspace.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity.Workspace}
 */
proto.worklayer.internal.v1.Opportunity.Workspace.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity.Workspace;
  return proto.worklayer.internal.v1.Opportunity.Workspace.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity.Workspace} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity.Workspace}
 */
proto.worklayer.internal.v1.Opportunity.Workspace.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.Workspace.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.Workspace.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity.Workspace} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Workspace.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.Workspace.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Workspace} returns this
 */
proto.worklayer.internal.v1.Opportunity.Workspace.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.Client.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Client.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    givenName: (f = msg.getGivenName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    familyName: (f = msg.getFamilyName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    displayName: (f = msg.getDisplayName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    picture: (f = msg.getPicture()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    userPublicId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity.Client}
 */
proto.worklayer.internal.v1.Opportunity.Client.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity.Client;
  return proto.worklayer.internal.v1.Opportunity.Client.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity.Client}
 */
proto.worklayer.internal.v1.Opportunity.Client.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setGivenName(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFamilyName(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDisplayName(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPicture(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.Client.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Client.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGivenName();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFamilyName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getPicture();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue given_name = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.getGivenName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
*/
proto.worklayer.internal.v1.Opportunity.Client.prototype.setGivenName = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.clearGivenName = function() {
  return this.setGivenName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.hasGivenName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue family_name = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.getFamilyName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
*/
proto.worklayer.internal.v1.Opportunity.Client.prototype.setFamilyName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.clearFamilyName = function() {
  return this.setFamilyName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.hasFamilyName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue display_name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.getDisplayName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
*/
proto.worklayer.internal.v1.Opportunity.Client.prototype.setDisplayName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.clearDisplayName = function() {
  return this.setDisplayName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.hasDisplayName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue picture = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.getPicture = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
*/
proto.worklayer.internal.v1.Opportunity.Client.prototype.setPicture = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.clearPicture = function() {
  return this.setPicture(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.hasPicture = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string user_public_id = 6;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Client} returns this
 */
proto.worklayer.internal.v1.Opportunity.Client.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.InfoLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity.InfoLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity.InfoLine}
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity.InfoLine;
  return proto.worklayer.internal.v1.Opportunity.InfoLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity.InfoLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity.InfoLine}
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.InfoLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity.InfoLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.InfoLine} returns this
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.InfoLine} returns this
 */
proto.worklayer.internal.v1.Opportunity.InfoLine.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.Legend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity.Legend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Legend.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    priceUnit: (f = msg.getPriceUnit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend}
 */
proto.worklayer.internal.v1.Opportunity.Legend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity.Legend;
  return proto.worklayer.internal.v1.Opportunity.Legend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity.Legend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend}
 */
proto.worklayer.internal.v1.Opportunity.Legend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setPriceUnit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.Legend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity.Legend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Legend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPriceUnit();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend} returns this
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend} returns this
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend} returns this
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.StringValue price_unit = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.getPriceUnit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend} returns this
*/
proto.worklayer.internal.v1.Opportunity.Legend.prototype.setPriceUnit = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity.Legend} returns this
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.clearPriceUnit = function() {
  return this.setPriceUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Legend.prototype.hasPriceUnit = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.Opportunity.Consultation.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.Consultation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity.Consultation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Consultation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    availabilityTimesList: jspb.Message.toObjectList(msg.getAvailabilityTimesList(),
    shared_types_interval_pb.Interval.toObject, includeInstance),
    requestedLength: (f = msg.getRequestedLength()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    skipScheduling: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity.Consultation;
  return proto.worklayer.internal.v1.Opportunity.Consultation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity.Consultation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new shared_types_interval_pb.Interval;
      reader.readMessage(value,shared_types_interval_pb.Interval.deserializeBinaryFromReader);
      msg.addAvailabilityTimes(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setRequestedLength(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipScheduling(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.Consultation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity.Consultation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.Consultation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAvailabilityTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      shared_types_interval_pb.Interval.serializeBinaryToWriter
    );
  }
  f = message.getRequestedLength();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getSkipScheduling();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation} returns this
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated worklayer.shared.types.v1.Interval availability_times = 2;
 * @return {!Array<!proto.worklayer.shared.types.v1.Interval>}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.getAvailabilityTimesList = function() {
  return /** @type{!Array<!proto.worklayer.shared.types.v1.Interval>} */ (
    jspb.Message.getRepeatedWrapperField(this, shared_types_interval_pb.Interval, 2));
};


/**
 * @param {!Array<!proto.worklayer.shared.types.v1.Interval>} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation} returns this
*/
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.setAvailabilityTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.worklayer.shared.types.v1.Interval=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.shared.types.v1.Interval}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.addAvailabilityTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.worklayer.shared.types.v1.Interval, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation} returns this
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.clearAvailabilityTimesList = function() {
  return this.setAvailabilityTimesList([]);
};


/**
 * optional google.protobuf.Duration requested_length = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.getRequestedLength = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation} returns this
*/
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.setRequestedLength = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation} returns this
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.clearRequestedLength = function() {
  return this.setRequestedLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.hasRequestedLength = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool skip_scheduling = 4;
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.getSkipScheduling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.v1.Opportunity.Consultation} returns this
 */
proto.worklayer.internal.v1.Opportunity.Consultation.prototype.setSkipScheduling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Opportunity.JobScopeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Opportunity.JobScopeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
    inventoryItemType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeItem}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Opportunity.JobScopeItem;
  return proto.worklayer.internal.v1.Opportunity.JobScopeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Opportunity.JobScopeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeItem}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {!proto.worklayer.internal.v1.Opportunity.JobScopeInventoryItemType} */ (reader.readEnum());
      msg.setInventoryItemType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Opportunity.JobScopeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Opportunity.JobScopeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getInventoryItemType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional JobScopeInventoryItemType inventory_item_type = 3;
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeInventoryItemType}
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.getInventoryItemType = function() {
  return /** @type {!proto.worklayer.internal.v1.Opportunity.JobScopeInventoryItemType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Opportunity.JobScopeInventoryItemType} value
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeItem} returns this
 */
proto.worklayer.internal.v1.Opportunity.JobScopeItem.prototype.setInventoryItemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Workspace workspace = 2;
 * @return {?proto.worklayer.internal.v1.Opportunity.Workspace}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getWorkspace = function() {
  return /** @type{?proto.worklayer.internal.v1.Opportunity.Workspace} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Opportunity.Workspace, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.Opportunity.Workspace|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional Client client = 5;
 * @return {?proto.worklayer.internal.v1.Opportunity.Client}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getClient = function() {
  return /** @type{?proto.worklayer.internal.v1.Opportunity.Client} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Opportunity.Client, 5));
};


/**
 * @param {?proto.worklayer.internal.v1.Opportunity.Client|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasClient = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Legend legend = 6;
 * @return {?proto.worklayer.internal.v1.Opportunity.Legend}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getLegend = function() {
  return /** @type{?proto.worklayer.internal.v1.Opportunity.Legend} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Opportunity.Legend, 6));
};


/**
 * @param {?proto.worklayer.internal.v1.Opportunity.Legend|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setLegend = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearLegend = function() {
  return this.setLegend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasLegend = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated string specs = 7;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getSpecsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.setSpecsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.addSpecs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearSpecsList = function() {
  return this.setSpecsList([]);
};


/**
 * repeated InfoLine info_lines = 8;
 * @return {!Array<!proto.worklayer.internal.v1.Opportunity.InfoLine>}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getInfoLinesList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Opportunity.InfoLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Opportunity.InfoLine, 8));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Opportunity.InfoLine>} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setInfoLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Opportunity.InfoLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Opportunity.InfoLine}
 */
proto.worklayer.internal.v1.Opportunity.prototype.addInfoLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.worklayer.internal.v1.Opportunity.InfoLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearInfoLinesList = function() {
  return this.setInfoLinesList([]);
};


/**
 * optional google.protobuf.Timestamp date_deadline = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getDateDeadline = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setDateDeadline = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearDateDeadline = function() {
  return this.setDateDeadline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasDateDeadline = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp date_created = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp date_modified = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getDateModified = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setDateModified = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearDateModified = function() {
  return this.setDateModified(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasDateModified = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp date_transmitted = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getDateTransmitted = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setDateTransmitted = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearDateTransmitted = function() {
  return this.setDateTransmitted(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasDateTransmitted = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal provider_cut_amount = 13;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getProviderCutAmount = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 13));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setProviderCutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearProviderCutAmount = function() {
  return this.setProviderCutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasProviderCutAmount = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated string legacy_job_scope_items = 14;
 * @return {!Array<string>}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getLegacyJobScopeItemsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.setLegacyJobScopeItemsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.addLegacyJobScopeItems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearLegacyJobScopeItemsList = function() {
  return this.setLegacyJobScopeItemsList([]);
};


/**
 * optional Consultation consultation = 15;
 * @return {?proto.worklayer.internal.v1.Opportunity.Consultation}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getConsultation = function() {
  return /** @type{?proto.worklayer.internal.v1.Opportunity.Consultation} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.Opportunity.Consultation, 15));
};


/**
 * @param {?proto.worklayer.internal.v1.Opportunity.Consultation|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setConsultation = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearConsultation = function() {
  return this.setConsultation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasConsultation = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional RoutingMode routing_mode = 16;
 * @return {!proto.worklayer.internal.v1.Opportunity.RoutingMode}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getRoutingMode = function() {
  return /** @type {!proto.worklayer.internal.v1.Opportunity.RoutingMode} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {!proto.worklayer.internal.v1.Opportunity.RoutingMode} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.setRoutingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp date_scheduled_dispatch = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getDateScheduledDispatch = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setDateScheduledDispatch = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearDateScheduledDispatch = function() {
  return this.setDateScheduledDispatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.Opportunity.prototype.hasDateScheduledDispatch = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated JobScopeItem job_scope_items = 18;
 * @return {!Array<!proto.worklayer.internal.v1.Opportunity.JobScopeItem>}
 */
proto.worklayer.internal.v1.Opportunity.prototype.getJobScopeItemsList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Opportunity.JobScopeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Opportunity.JobScopeItem, 18));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Opportunity.JobScopeItem>} value
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
*/
proto.worklayer.internal.v1.Opportunity.prototype.setJobScopeItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Opportunity.JobScopeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Opportunity.JobScopeItem}
 */
proto.worklayer.internal.v1.Opportunity.prototype.addJobScopeItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.worklayer.internal.v1.Opportunity.JobScopeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.Opportunity} returns this
 */
proto.worklayer.internal.v1.Opportunity.prototype.clearJobScopeItemsList = function() {
  return this.setJobScopeItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.ListQualifiedProvidersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    qualifiedProvidersList: jspb.Message.toObjectList(msg.getQualifiedProvidersList(),
    proto.worklayer.internal.v1.Provider.toObject, includeInstance),
    nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.ListQualifiedProvidersResponse;
  return proto.worklayer.internal.v1.ListQualifiedProvidersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.v1.Provider;
      reader.readMessage(value,proto.worklayer.internal.v1.Provider.deserializeBinaryFromReader);
      msg.addQualifiedProviders(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.ListQualifiedProvidersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQualifiedProvidersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.worklayer.internal.v1.Provider.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Provider qualified_providers = 1;
 * @return {!Array<!proto.worklayer.internal.v1.Provider>}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.getQualifiedProvidersList = function() {
  return /** @type{!Array<!proto.worklayer.internal.v1.Provider>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.worklayer.internal.v1.Provider, 1));
};


/**
 * @param {!Array<!proto.worklayer.internal.v1.Provider>} value
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse} returns this
*/
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.setQualifiedProvidersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.worklayer.internal.v1.Provider=} opt_value
 * @param {number=} opt_index
 * @return {!proto.worklayer.internal.v1.Provider}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.addQualifiedProviders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.worklayer.internal.v1.Provider, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse} returns this
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.clearQualifiedProvidersList = function() {
  return this.setQualifiedProvidersList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.ListQualifiedProvidersResponse} returns this
 */
proto.worklayer.internal.v1.ListQualifiedProvidersResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legend: (f = msg.getLegend()) && proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.toObject(includeInstance, f),
    workspace: (f = msg.getWorkspace()) && proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.toObject(includeInstance, f),
    client: (f = msg.getClient()) && proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent;
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend;
      reader.readMessage(value,proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.deserializeBinaryFromReader);
      msg.setLegend(value);
      break;
    case 3:
      var value = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace;
      reader.readMessage(value,proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.deserializeBinaryFromReader);
      msg.setWorkspace(value);
      break;
    case 4:
      var value = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client;
      reader.readMessage(value,proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegend();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.serializeBinaryToWriter
    );
  }
  f = message.getWorkspace();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.serializeBinaryToWriter
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace;
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend;
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userPublicId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client;
  return proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_public_id = 2;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Legend legend = 2;
 * @return {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.getLegend = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend, 2));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Legend|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.setLegend = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.clearLegend = function() {
  return this.setLegend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.hasLegend = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Workspace workspace = 3;
 * @return {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.getWorkspace = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace, 3));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Workspace|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.setWorkspace = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.clearWorkspace = function() {
  return this.setWorkspace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.hasWorkspace = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Client client = 4;
 * @return {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.getClient = function() {
  return /** @type{?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client, 4));
};


/**
 * @param {?proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.Client|undefined} value
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
*/
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.v1.OpportunityRemovedRealtimeEvent.prototype.hasClient = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.Provider.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.Provider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.Provider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Provider.toObject = function(includeInstance, msg) {
  var f, obj = {
    userPublicId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.Provider}
 */
proto.worklayer.internal.v1.Provider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.Provider;
  return proto.worklayer.internal.v1.Provider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.Provider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.Provider}
 */
proto.worklayer.internal.v1.Provider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPublicId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.Provider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.Provider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.Provider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.Provider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserPublicId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_public_id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.Provider.prototype.getUserPublicId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.Provider} returns this
 */
proto.worklayer.internal.v1.Provider.prototype.setUserPublicId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent}
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent;
  return proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent}
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent} returns this
 */
proto.worklayer.internal.v1.OpportunityOfferRemovedRealtimeEvent.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.worklayer.internal.v1);
